import { CSS, StyleProps } from "@shared/primitive-components"

export const marginBottom = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(7),
})

export const fontSize = (props: StyleProps): CSS => ({
  fontSize: props.theme.fontSize.caption,
})

export const fullWidth = (): CSS => ({
  width: `100%`,
})

export const makeCellStyle =
  (alignRight?: boolean) =>
  (props: StyleProps): CSS => ({
    ...props.theme.fonts.subHeading,
    textAlign: alignRight ? `right` : undefined,
    marginRight: props.theme.spacing(4),
    fontSize: props.theme.fontSize.caption,
  })
